import create from 'zustand';
import { devtools } from 'zustand/middleware';

import api from 'api';

type ActionsHook = {
  url?: string
  row?: any
  action?: 'delete' | 'restore'
  onDelete: (_url: string, _row:any) => void
  onRestore: (_row: string) => Promise<any>
  confirmDelete: () => Promise<any>
  onClear: () => void
}

const useActions = create<ActionsHook>(devtools((set, get) => ({
  row: {},
  action: null,
  onDelete: (url: string, row: any) => set(() => ({ action: 'delete', url, row })),
  onRestore: async (url: string) => api().patch(url),
  confirmDelete: async () => api().delete(get().url),
  onClear: () => set(() => ({ action: null })),
})));

export default useActions;
